import AGSLoopWins from "ags/states/ags-loop-wins";
import BigBorderIgnoreWildWindMediator from "mediators/big-border-ignore-wild-win-mediator";

export default class CGLoopWins extends AGSLoopWins {

    protected loopWinsMediator: BigBorderIgnoreWildWindMediator;

    public onEnter() {
        this.loopWinsMediator = new BigBorderIgnoreWildWindMediator();
        this.loopWinsMediator.start().then(() => this.complete());
    }
}
